import { textFieldStyles } from '@components/PropertySearchFilters/styles';
import { TextField } from '@mui/material';
import { formatNumber } from '@util/formatNumber';
import { ChangeEvent, FC } from 'react';
import { BetweenDash, TextContainer, ValidationError } from '../styles';
import { FieldType } from '../types';

interface TextSectionProps {
  minVal?: number | null;
  maxVal?: number | null;
  field: FieldType;
  handleTextFieldChange: (e: ChangeEvent<HTMLInputElement>, field: FieldType, min?: 'min') => void;
  isPrice?: true;
}

export const TextSection: FC<TextSectionProps> = ({
  minVal,
  maxVal,
  handleTextFieldChange,
  isPrice,
  field,
}) => {
  return (
    <>
      <TextContainer data-testid="price-range">
        <TextField
          data-testid={`${field}-min`}
          variant="outlined"
          value={minVal || minVal === 0 ? formatNumber(minVal!) : ''}
          placeholder={'0'}
          slotProps={{
            input: {
              name: 'minValue',
              ...((isPrice && minVal) || minVal === 0 ? { isPrice: true } : { placeholder: '0' }),
            },
          }}
          onInput={(e: any) => {
            e.target.value = e.target.value.replace(/[^0-9]/g, '');
          }}
          onChange={(e) => handleTextFieldChange(e as ChangeEvent<HTMLInputElement>, field, 'min')}
          size="small"
          sx={textFieldStyles}
          type={'string'}
        />
        <BetweenDash>–</BetweenDash>
        <TextField
          data-testid={`${field}-max`}
          variant="outlined"
          value={maxVal || maxVal === 0 ? formatNumber(maxVal) : ''}
          placeholder={'1000000'}
          slotProps={{
            input: {
              lang: 'en-US',
              name: 'maxValue',
              ...((isPrice && maxVal) || maxVal === 0
                ? {
                    isPrice: true,
                  }
                : {
                    placeholder: '1000000',
                  }),
            },
          }}
          onInput={(e: any) => {
            e.target.value = e.target.value.replace(/[^0-9]/g, '');
          }}
          onChange={(e) => handleTextFieldChange(e as ChangeEvent<HTMLInputElement>, field)}
          size="small"
          sx={textFieldStyles}
          type={'string'}
        />
      </TextContainer>
      {typeof minVal === 'number' && typeof maxVal === 'number' && minVal >= maxVal && (
        <ValidationError>* Min value should be less than max value</ValidationError>
      )}
    </>
  );
};
